var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo_x5F_contacts_x5F_192px_1_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    enableBackground: "new 0 0 500 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "art_layer"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "bg_circle",
    fill: "#1A73E8",
    cx: 250,
    cy: 250,
    r: 250
  }), /*#__PURE__*/React.createElement("path", {
    id: "body_shadow",
    fill: "#185ABC",
    d: "M332.4,375H170.5c-19.6,0-36.9-11.8-36.9-31.2V358c0,19.4,17.3,34.1,36.9,34.1h161.9 c19.6,0,36.9-14.7,36.9-34.1v-14.2C369.3,363.2,352,375,332.4,375z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "head_shadow",
    fill: "#185ABC",
    d: "M250,227.3c-29.3-0.1-52.4-20.4-54-48.3v11.4c0,28.9,24.2,54,54,54s54-25.1,54-54V179 C301.7,207.1,279.3,227.4,250,227.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "subject"
  }, /*#__PURE__*/React.createElement("path", {
    id: "body",
    fill: "#FFFFFF",
    d: "M250,261.4c-57,0-116.5,27.8-116.5,65.3v17c0,19.4,15.9,34.1,35.5,34.1h164.7 c19.6,0,35.5-14.7,35.5-34.1v-17C369.3,289.1,307,261.4,250,261.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "head",
    fill: "#FFFFFF",
    cx: 250,
    cy: 176.1,
    r: 54
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/ContactIcon.5f0f9e4a4ef7099f3c699e13b4996e23.svg";
export { ForwardRef as ReactComponent };